export default __webpack_public_path__ + "static/media/br_03.f7de11ff.jpg";